import type { ComponentType } from 'react';

import type { PromoRendererProps } from '@ps-int/promozavr/app/PromoRenderer';

import { FALLBACK_COMPONENTS, ModuleFederationComponents } from '../module-federation/constants';
import { fedyaModuleFederation as moduleFederation } from '../module-federation/module-federation';
import type { PromozavrRendererSource } from './types';

const FALLBACK_PROMO_RENDERER_MODULE = FALLBACK_COMPONENTS[ModuleFederationComponents.PromoRenderer];

function getPromoRendererModule() {
    return (
        moduleFederation?.getComponent<ModuleFederationComponents.PromoRenderer>(
            ModuleFederationComponents.PromoRenderer
        ) ?? FALLBACK_PROMO_RENDERER_MODULE
    );
}

export function getPromozavrRendererSource(shouldUsePdokPromoRenderer: boolean): PromozavrRendererSource {
    if (!shouldUsePdokPromoRenderer) {
        return 'local';
    }

    const promoRendererModule = getPromoRendererModule();

    if (promoRendererModule !== FALLBACK_PROMO_RENDERER_MODULE) {
        return 'remote';
    }

    return 'local';
}

export function getPromozavrRenderer(rendererSource: PromozavrRendererSource): ComponentType<PromoRendererProps> {
    if (rendererSource !== 'remote') {
        return FALLBACK_PROMO_RENDERER_MODULE.default;
    }

    return getPromoRendererModule().default ?? FALLBACK_PROMO_RENDERER_MODULE.default;
}
